import { ReactNode } from "react"

import { ExclamationTriangleIcon, NoSymbolIcon } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"

export type InsightsPanelProps = {
  className?: string
  children: ReactNode
}

export type InsightsPanelHeaderProps = {
  title: string
  className?: string
  children?: React.ReactNode
}

export type InsightsPanelContentProps = {
  className?: string
  children: ReactNode
}

export type InsightsPanelFooterProps = {
  className?: string
  children: ReactNode
}

export function InsightsPanel({ className, children }: InsightsPanelProps) {
  return (
    <div
      className={twMerge("flex h-full w-full flex-col rounded-lg border border-gray-200 bg-white shadow-sm", className)}
    >
      {children}
    </div>
  )
}

export function InsightsPanelHeader({
  title,
  className,
  children,
}: {
  title: string
  className?: string
  children?: React.ReactNode
}) {
  return (
    <div className={twMerge("flex justify-between gap-1 border-b border-gray-200 px-4 py-2", className)}>
      <h1 className="text-large flex items-center font-medium">{title}</h1>
      {children}
    </div>
  )
}

export function InsightsPanelContent({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={twMerge("flex-1", className)}>{children}</div>
}

export function InsightsPanelFooter({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div className={twMerge("flex items-center justify-between border-t border-gray-200 px-4 py-2", className)}>
      {children}
    </div>
  )
}

export function InsightsPanelNoDataDefault() {
  return (
    <div className="flex h-full flex-col items-center justify-center p-8 text-sm text-gray-500">
      <span className="mb-2 text-gray-400">
        <NoSymbolIcon className="h-6 w-6" />
      </span>
      <p>No data available.</p>
    </div>
  )
}

export function InsightsPanelErrorDefault() {
  return (
    <div className="flex h-full flex-col items-center justify-center p-8 text-sm text-gray-500">
      <span className="mb-2 text-gray-400">
        <ExclamationTriangleIcon className="h-6 w-6" />
      </span>
      <p>Unable to load data.</p>
      <p>Please refresh or try again later.</p>
    </div>
  )
}
